import React from 'react';
import styled from 'styled-components';
import {
  Button,
  Modal,
} from '@bijie/react-bnb';
import withI18n from '../../utils/withI18n';
import { getLabel } from '../../utils/i18n';

const Wrapper = styled.div`
  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .checkboxDiv {
    display: block;
    margin-top: 20px;
    font-size: 14px;
  }
  .title {
    font-size: 20px;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
  .context {
    font-size: 14px;
    color: #485e5d;
  }
  .modal-btn {
    width: 160px;
  }
  .footer {
    margin-top: 30px;
  }
`;
type Props = {
  context: string,
  buttonText: string,
  i18n: Object,
  goto: Function,
  onRef: Function,
};
export default
@withI18n
class CreditCardPage extends React.Component<Props> {
  static defaultProps = {
    i18n: Object,
    onRef: () => {},
    goto: () => {},
    buttonText: '',
    context: '',
  }

  state = {
    visible: false,
    isDisclaimerChecked: false,
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  _handleDisclaimer = () => {
    const { isDisclaimerChecked } = this.state;
    this.setState({ isDisclaimerChecked: !isDisclaimerChecked });
  }

  close = () => {
    this.setState({ visible: false });
  }

  open = () => {
    this.setState({
      visible: true,
    });
  }

  goto = () => {
    this.close();
    this.props.goto();
  }

  render() {
    const { i18n, context, buttonText } = this.props;
    const { isDisclaimerChecked, visible } = this.state;
    return (
      <Modal footer={null} className="buy-sell-desclaimer-modal" visible={visible} onClose={this.close}>
        <Wrapper>
          <h2 className="title">{getLabel('Disclaimer', i18n)}</h2>
          <div className="context">
            {context}
          </div>
          <label htmlFor="disclaimer" className="checkboxDiv">
            <input
              id="disclaimer"
              type="checkbox"
              required={true}
              value="test"
              checked={isDisclaimerChecked}
              onClick={this._handleDisclaimer}
              style={{ cursor: 'pointer' }}
            />
            <span>&nbsp;{getLabel('exchange-creditcard-readAgreedDisclaimer', i18n)}</span>
          </label>
          <div className="footer">
            <Button
              className="modal-btn"
              onClick={this.close}
            >
              {getLabel('exchange-common-cancel', i18n)}
            </Button>
            <Button
              className="modal-btn"
              onClick={this.goto}
              disabled={!isDisclaimerChecked}
              type="primary"
            >
              {buttonText}
            </Button>
          </div>
        </Wrapper>
      </Modal>
    );
  }
}
